import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=452147f0&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=452147f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452147f0",
  null
  
)

export default component.exports